// extracted by mini-css-extract-plugin
export var actionsRow = "_10-a";
export var actionsRowEnd = "_10-b";
export var askRedoBlackBtn = "_10-d";
export var askRedoBlackBtnIcon = "_10-e";
export var exitModalActionBtn = "_10-c";
export var exitModalRoot = "_10-0";
export var followUpInput = "_10-9";
export var modalContentBody = "_10-7";
export var modalHeaderImage = "_10-2";
export var modalImageLabel = "_10-4";
export var modalImageOverlay = "_10-3";
export var modalImageSubheading = "_10-6";
export var modalImageTitle = "_10-5";
export var modalImageWrapper = "_10-1";
export var reasonCard = "_10-f";
export var reasonCardSelected = "_10-g";
export var reasonIcon = "_10-j";
export var reasonIconWrap = "_10-i";
export var reasonIndicator = "_10-l";
export var reasonIndicatorDot = "_10-n";
export var reasonIndicatorSelected = "_10-m";
export var reasonLabel = "_10-h";
export var reasonList = "_10-8";
export var reasonTitle = "_10-k";